// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../graphql/api/index';

export const GemsApiCertificateFragmentDoc = `
    fragment gemsApiCertificate on GemsApi_Stone {
  certificates {
    gcal
    gia
    igi
  }
}
    `;